module.exports = __webpack_public_path__ + "static/media/unionpay-logo.3477adce.svg";